import logo from './logo.svg';
import './App.css';
import CryptoBubbles from './components/CryptoBubbles';
import vsb from './images/vsb.jpg';
import wiftrade from './images/wiftrade.jpg';
import idosol from './images/idosol.png';
import meme from "./images/meme.png";
import andei from "./images/andei.png";
import diddy from "./images/diddy.png";
import fwoon from "./images/fwoon.png";
import beast from "./images/beast.png";
import babycaller from "./images/babycaller.jpg";

import mastercat from "./images/mastercat.jpg";
import theone from "./images/theone.jpg";
import dracula from "./images/dracula.jpg";
import mumu from "./images/mumu.jpg";
import wulf from "./images/wulf.jpg";
import weibo from "./images/weibo.jpg";
import MM from "./images/MM.jpg";
import panda from "./images/panda.jpg";
import kingkong from "./images/kingkong.jpg";
import travel from "./images/travel.jpg";
import shen from "./images/shen.jpg";
import kat from "./images/kat.jpg";
import p24 from "./images/p24.jpg";
import nyopepe from "./images/nyopepe.jpg";
import rimumu from "./images/rimumu.jpg";
import roratexd from "./images/roratexd.jpg";
import solgota from "./images/solgota.jpg";
import x9 from "./images/x9.jpg";
import zenitsu from "./images/zenitsu.jpg";
import ravi from "./images/ravi.jpg";
import { useState } from 'react';

function App() {


  const cryptoMockData = [
    {
      id: '1',
      name: 'IDOSOL',
      logo: idosol,
      link: 'https://t.me/idosolme',
      radius: 110,
      type: "main",
      color: '#9D139D',
    },
    {
      id: '2',
      name: 'Wiftrade',
      link: 'https://t.me/wiftrade_bot',
      logo: wiftrade,
      radius: 80,
      type: "product",
      color: '#FFFFFF',
    },
    {
      id: '3',
      logo: vsb,
      link: 'https://t.me/VolumeSolana_bot',
      name: 'VSB',
      radius: 80,
      type: "product",
      color: '#FFFFFF',
    },
    {
      id: '4',
      logo: meme,
      name: 'Meme x9999',
      link: 'https://t.me/memex9999call',
      radius: 60,
      type: "group",
      color: '#647EE9',
    },
    {
      id: '5',
      logo: mastercat,
      name: 'KAT',
      link: 'https://t.me/Kat_ZoRR',
      radius: 60,
      type: "group",
      color: '#647EE9',
    },
    {
      id: '6',
      logo: theone,
      name: 'The One Signal',
      radius: 60,
      type: "group",
      link: 'https://t.me/theone_signal',
      color: '#647EE9',
    },
    {
      id: '7',
      logo: MM,
      name: 'Money Maker',
      radius: 60,
      type: "group",
      link: 'https://t.me/Money_MakerMM',
      color: '#647EE9',
    },
    {
      id: '8',
      logo: dracula,
      name: 'Dracula Gamble',
      radius: 60,
      type: "group",
      link: 'https://t.me/DraculaGamble',
      color: '#647EE9',
    },
    {
      id: '9',
      logo: kingkong,
      name: 'Kong on Chain',
      radius: 60,
      type: "group",
      link: 'https://t.me/Kong_on_Chain',
      color: '#647EE9',
    },
    {
      id: '10',
      logo: babycaller,
      name: 'BABY CALLER',
      radius: 60,
      type: "group",
      link: 'https://t.me/BabieCaller',
      color: '#647EE9',
    },
    {
      id: '11',
      logo: mumu,
      name: 'Mfers',
      radius: 60,
      type: "group",
      link: 'https://t.me/p24greencandle',
      color: '#647EE9',
    },
    {
      id: '12',
      logo: panda,
      name: 'Panda Caller',
      radius: 60,
      type: "group",
      link: 'https://t.me/Panda_X1000',
      color: '#647EE9',
    },
    {
      id: '13',
      logo: travel,
      name: 'Travel Caller',
      radius: 60,
      type: "group",
      link: 'https://t.me/TV_CALLS',
      color: '#647EE9',
    },
    {
      id: '14',
      logo: weibo,
      name: 'Weibo Gambles',
      radius: 60,
      type: "group",
      link: 'https://t.me/WeiboGambles',
      color: '#647EE9',
    },
    {
      id: '15',
      logo: wulf,
      name: 'Wulfden',
      radius: 60,
      type: "group",
      link: 'https://t.me/WulfdenX',
      color: '#647EE9',
    },
    {
      id: '16',
      logo: shen,
      name: 'Shen (🐬,🤡)',
      radius: 60,
      type: "kol",
      link: 'https://x.com/IDoNoThlnG',
      color: '#F3BA2F',
    },
    {
      id: '17',
      logo: p24,
      name: 'P24',
      radius: 60,
      type: "kol",
      link: 'https://x.com/pumpboyykb/photo',
      color: '#F3BA2F',
    },
    {
      id: '18',
      logo: kat,
      name: 'KAT 🧠',
      radius: 60,
      type: "kol",
      link: 'https://x.com/KatZoR___/photo',
      color: '#F3BA2F',
    },
    {
      id: '19',
      logo: rimumu,
      name: 'Rimuru',
      radius: 60,
      type: "kol",
      link: 'https://x.com/Rimuru_Predator/photo',
      color: '#F3BA2F',
    },
    {
      id: '20',
      logo: roratexd,
      name: 'Rotate XD',
      radius: 60,
      type: "kol",
      link: 'https://x.com/0xOGppl',
      color: '#F3BA2F',
    },
    {
      id: '21',
      logo: solgota,
      name: 'Solgota',
      radius: 60,
      type: "kol",
      link: 'https://x.com/RealOG_F',
      color: '#F3BA2F',
    },
    {
      id: '22',
      logo: nyopepe,
      name: 'Nyo Pepe',
      radius: 60,
      type: "kol",
      link: 'https://x.com/Nyopepee/photo',
      color: '#F3BA2F',
    },
    {
      id: '23',
      logo: x9,
      name: 'X9',
      radius: 60,
      type: "kol",
      link: 'https://x.com/CodedX9/photo',
      color: '#F3BA2F',
    },
    {
      id: '24',
      logo: zenitsu,
      name: 'Zenitsu',
      radius: 60,
      type: "kol",
      link: 'https://x.com/Zenitsukol/photo',
      color: '#F3BA2F',
    },
    {
      id: '25',
      logo: ravi,
      name: 'Ravi',
      radius: 60,
      type: "kol",
      link: 'https://x.com/Rav1HP',
      color: '#F3BA2F',
    },
    {
      id: '27',
      logo: andei,
      name: 'ANDEI (2M$)',
      radius: 40,
      type: "project",
      color: '#1F8855',
    },
    {
      id: '28',
      logo: beast,
      name: 'BEAST (4M$)',
      radius: 40,
      type: "project",
      color: '#1F8855',
    },
    {
      id: '29',
      logo: diddy,
      name: 'DIDDY (8M$)',
      radius: 40,
      type: "project",
      color: '#1F8855',
    },
  ];

  const [list, setList] = useState(cryptoMockData)

  return (
    <div className="App" >
      <div>
        <button onClick={() => {
          setList(cryptoMockData)
        }}>All</button>
        <button onClick={() => {
          setList(cryptoMockData.filter(item => item.type === "main"))
        }}>Main</button>
        <button onClick={() => {
          setList(cryptoMockData.filter(item => item.type === "product"))
        }}>Product</button>
        <button onClick={() => {
          setList(cryptoMockData.filter(item => item.type === "group"))
        }}>Group</button>
        <button onClick={() => {
          setList(cryptoMockData.filter(item => item.type === "kol"))
        }}>KOL</button>
        <button onClick={() => {
          setList(cryptoMockData.filter(item => item.type === "project"))
        }}>Project</button>
      </div>

      <CryptoBubbles data={list} />
    </div>
  );
}

export default App;
